import { ComponentFactory, ComponentFactoryResolver } from '@angular/core';
import { MarkedOptions, MarkedRenderer } from 'ngx-markdown';
import { PostMessageService, WindowPostMessageAction } from '../services/post-message.service';

export const markedOptionsFactory = (
  postMessageService: PostMessageService
): MarkedOptions => {
  const renderer = new MarkedRenderer();

  // @ts-expect-error
  window.handleMdLinkClick = function (e: Event) {
    const el = e.target as HTMLAnchorElement
    if (!el || !el.dataset) {
      return
    }

    const postMessage = el.dataset['postMessage']
    const postMessageAction = el.dataset['postMessageAction'] as WindowPostMessageAction | undefined

    if (!postMessage || !postMessageAction) {
      return
    }

    // Links to a different domain/subdomain than the parent app should open in
    // a new tab (default anchor behaviour with target="_blank") instead of
    // navigating inside the parent page via postMessage.
    if (!postMessageService.isSameHostAsParent(postMessage)) {
      return
    }

    e.preventDefault()
    e.stopPropagation()
    postMessageService.sendMessage(postMessage, postMessageAction)
  }

  renderer.link = ({ href, text }): string => {
    return `<a href="${href}" onclick="handleMdLinkClick(event)" data-post-message="${href}" data-post-message-action="${WindowPostMessageAction.OPEN_LINK}" target="_blank" rel="noopener noreferrer">${text}</a>`;
  };

  return {
    renderer: renderer,
    gfm: true,
    breaks: true,
    pedantic: false,
  };
};
